import { useOffersDE } from '../../hooks/useOffers/useOffersDE';
import ApplicationLoader from '../ApplicationLoader/ApplicationLoader';
import OffersCheck from '../OffersCheck/OffersCheck';

const OffersWithOffersCheckDE = () => {
  const offersInformation = useOffersDE();

  return (
    <OffersCheck {...offersInformation}>
      <ApplicationLoader />
    </OffersCheck>
  );
};

export default OffersWithOffersCheckDE;
